import React from "react";
import classNames from "classnames";

interface ParagraphProps {
  children: React.ReactNode;
  className?: string;
  text32?: boolean;
  text24?: boolean;
  text22?: boolean;
  text20?: boolean;
  text18?: boolean;
  text16?: boolean;
  text14?: boolean;
  text12?: boolean;
  [key: string]: any;
  style?: any;
  onClick?: (e: React.MouseEvent<HTMLParagraphElement>) => void;
}

function Paragraph({
  children,
  className,
  text32,
  text24,
  text22,
  text20,
  text18,
  text16,
  text14,
  text12,
  onClick,
  style,
  ...props
}: ParagraphProps) {
  const classes = classNames({
    "lg:text-[32px] md:leading-[31px] md:text-[28px] text-[26px] leading-[27px] font-semibold":
      text32,
    "md:text-[24px] md:leading-[22px] text-[22px] leading-[20px] font-medium":
      text24,
    "md:text-[22px] md:leading-[21px] text-[20px] leading-[19px] font-medium":
      text22,
    "md:text-[20px] md:leading-[19px] text-[18px] leading-[17px]": text20,
    "md:text-[18px] md:leading-[28px] text-[16px] leading-[24px] font-medium":
      text18,
    "text-[16px] leading-[24px]": text16,
    "text-[14px] leading-[21px] font-semibold": text14,
    "text-[12px] leading-[17px]": text12,
  });

  return (
    <p
      className={`text-site-black ${classes} ${className ? className : ""}`}
      onClick={onClick}
      style={style}
    >
      {children}
    </p>
  );
}

export default Paragraph;
